export const HOME_RANK_LATEST = "latest"
export const HOME_RANK_HOT = "hot"
export const HOME_RANK_RECOMMEND = "recommend"
